import data from './radar.data'
import itemStyle from './radar.itemStyle'
import label from './radar.label'
import lineStyle from './radar.lineStyle'
import areaStyle from './radar.areaStyle'
import tooltip from './radar.tooltip'

export default {
  name: "radar",
  nickname: "雷达",
  desc: "radar",
  type: "object",
  props: {
    name: {
      name: "name",
      nickname: "名称",
      desc:
        '系列名称，用于<a target="__blank" href="https://echarts.apache.org/zh/option.html#tooltip">tooltip</a>的显示，<a target="__blank" href="https://echarts.apache.org/zh/option.html#legend">legend</a> 的图例筛选，在 <code class="codespan">setOption</code> 更新数据和配置项时用于指定对应的系列。',
    },
    data,
    itemStyle,
    label,
    lineStyle,
    areaStyle,
    tooltip,
    type: {
      name: "type",
      nickname: "类型",
      desc: "type",
      value: "",
      defaultValue: "",
      type: "pureValue",
    },
  },
}
